<div class="breadcrumb">
  <h3>
    {{ title }}
  </h3>
  <p>
    {{ path }}
  </p>
</div>
